export const numericRegex = /^(?:[0-9]|[1-9][0-9]+)(?:\.[0-9]+)?$/;
export const integerRegex = /^(?:[0-9]|[1-9][0-9]+)$/;
export const emailRegex = /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const phoneRegex = /^\+?[0-9\s]*$/;
export const uuidv4Regex =
  /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
